import { Component, OnInit, ViewChild } from '@angular/core';
import { GridBaseCase } from '../../grid/grid.base.case';
import { WebParameterContext } from '../../../../model/common';
import { Platform, IonInfiniteScroll, ModalController } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { NativeService } from '../../../../service/native.service';
import { BaseCase } from '../../../basecase';
import { BaseModal } from '../../../../model/base';
import { MzModalPage } from 'src/app/page/nestle/mz-modal/mz-modal.page';
import { ReasonsDifferencesPage } from '../../reasons-differences/reasons-differences.page'
import { NONE_TYPE } from '@angular/compiler/src/output/output_ast';
declare var app;
@Component({
  selector: 'app-a2-product-inventory',
  templateUrl: './a2-product-inventory.component.html',
  styleUrls: ['./a2-product-inventory.component.scss']
})
export class A2ProductInventoryComponent extends GridBaseCase {
  CustomInterfaceOptions: any = {
    header: '产品列表',
    // subHeader: 'Select your toppings',
    // message: '$1.00 per topping',
    // translucent: true
  };
  
  month: any = new Date();
  segmentVal: any = 0;
  typeout: any = null;
  searchDate = null;
  searcholdDate = null;
  isSelectCahage: boolean = false;//是否多次点击
  // dataArrayList: Array<any> = [];
  productArrayList: Array<any> = [];
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  RecordCount: Number = 0;//列表总数量
  addobject: any = {};//多选
  pageName: string = null;
  isAddProduct: boolean = true;//是否可以添加产品
  isSubmitData: boolean = true;//是否可以提交数据
  isAndroid4: boolean = false;//安卓4以下
  max: any;//最大日期
  isreturnGoods: boolean = false;//是否退货页面
  isProductInventory:boolean=true;//是否可以提交盘库
  Remark: string = "";//消费者退货备注
  tempArrayList:Array<any> = [];
  nonetyle:any = 'none';
  isCheck :number = 0;
  _type:any;//判断类型
  modalSHOE:boolean = false;
  cravingforRemk:string = ""; // 差异原因
  reasonsforDifferencesList:Array<any>=[];
  modalSHOEremark:boolean=false; // 是否显示差异原因
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    private native: NativeService,
    public baseService: BaseCase,
    public base: BaseModal,
    public modal: ModalController

  ) {
    super();
    this.pageName = this.activaRouter.snapshot.paramMap.get('ConfigName');
    if (this.pageName == "ReturnGoods") {//消费者退货
      this.isreturnGoods = true;
      this.baseService.arrayData = [];
    }
    // this.getProductList();
    this.baseService.FixedSubmitBtn.configName = "ProductInventory";
    this.baseService.FixedSubmitBtn.isShow = true;
    this.baseService.FixedSubmitBtn.text = "提交";
    this.baseService.FixedSubmitBtn.isSubmitData=true;
    this.baseService.FixedSubmitBtn.type = 1;

    this.isAndroid4 = this.com.Isandroidversion;
    this.max = this.com.TenTime;
    this.reasonsforDifferences();
    // 修改底部按钮是否显示
    // document.getElementsByTagName('body')[0].style.setProperty('', '');
  }
  EventLink(event, item) {
    // console.log(item);
    localStorage.setItem("information", JSON.stringify(item));
    this.com.setHistoryUrl();
    // this.router.navigate([event.url + item.id.value]);
    this.com.Go(event.url + item.id.value);
  }

  /**
   * 生产日期android5以下
   * @param item 选中的数据
   */
  EventClickTime(item) {
    // const that=this;
    // let val = item.orderCreateDate.value || "";
    // let obj = {};
    // if(val){
    //   const _val = val.replace(/-/g,"/");
    //   const _date = new Date(_val);
    //   const _month = _date.getMonth()+1;
    //   const _day = _date.getDate();
    //   const d = _date.getFullYear() + "-" + _month + "-" + _day;
    //   obj["value"]=d;
    // }else{
    //   const _date = new Date();
    //   obj["value"] = _date.getFullYear()+"-"+(_date.getMonth() + 1)+"-"+_date.getDate();
    // }
    // obj["format"]="yyyymmdd";
    // that.native.IosselectDateTime(obj).then(data=>{
    //   const _val = data.value.replace(/-/g,"/");
    //   const _date = new Date(_val);
    //   const _month = _date.getMonth()+1;
    //   const _day = _date.getDate();
    //   const d = _date.getFullYear() + "-" + (_month < 10?("0" + _month):_month) + "-" + (_day < 10?("0" + _day):_day);
    //   item.orderCreateDate.value = d;
    // }).catch(eror=>{
    // });
  }
  loadMoreData(event) {
    let that = this;
    if (that.RecordCount == that.baseService.arrayData.length) {
      if (that.infiniteScroll) {
        that.infiniteScroll.disabled = true;
      }

    }
      that.PageNumber++;
      this.LoadData(that.PageNumber);

    
  }
  LoadData(PageNumber) {
    let that = this;
    if (this.pageName == "ReturnGoods") {//消费者退货
      that.loading = true;
      // that.apiObj['status'] = false;
      // that.apiObj['msg'] = '暂无数据';
      return;
    }
    // console.log("1008611");
    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
      localStorage.removeItem("arrrayListINFO");
    }
    // console.log(that.element);
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    } else {
      that.msg.Alert("服务端数据配置有误,请联系管理员");
      return;
    }
    // body.ConfigName="MemberManage";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    let typeObj = {};
    // if(PageName == 'RepurchaseReminder'){
    //   typeObj = {"Type":1};
    // }else if(PageName == 'TransitionReminder'){
    //   typeObj = {"Type":2};
    // }else if(PageName == 'AwakenReminder'){
    //   typeObj = {"Type":3};
    // }else if(PageName == 'BirthdayReminder'){
    //   typeObj = {"Type":4};
    // }else if(PageName == 'NewcustomersReminder'){
    //   typeObj = {"Type":5};
    // }
    // body.RequestBody = JSON.stringify(typeObj);
    let arrayListInfo:Array<any> = [];
    that.http.post(app.DEFAULTURL, body).then(data => {

      /****判断是否第一页begin****/
      if (PageNumber == 1) {
        that.baseService.arrayData = [];
        // that.dataArrayList = [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      } else {
        if (that.infiniteScroll) {
          that.infiniteScroll.complete();
        }

      }
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        that.isProductInventory=data.Status.isapprove;//data.Status.isapprove;
        that.baseService.FixedSubmitBtn.isSubmitData=data.Status.isapprove;
        data.Status.Datas.forEach(function (item) {
          let objfield = {"csum":{value:0,text:"手动"}};
          that.element.selectItemList.selectItem.forEach((element, index) => {
            if (element.bindingField) {
              objfield[element.bindingField] = { "value": item[element.field], "text": element.text };
            }
            if(objfield["stock"]){
              if(!objfield["stock"].value){
                objfield["stock"].value=0;
              }
            }
            // objfield["csum"].value=null;
            // objfield["modalSHOE"] =false;
            // objfield["seceltName"] = "请选择";
            // objfield["FK_TBReasonsProductInventoryDifferences_ID"] ="";
          });
          arrayListInfo.push(objfield);
          that.baseService.arrayData.push(objfield);
          // console.log(that.baseService.arrayData)

          // that.dataArrayList.forEach(data=>{
          //   if(data.orderCreateDate.value){
          //     let datepie: DatePipe = new DatePipe("en-US");
          //     data.orderCreateDate.value =  datepie.transform(data.orderCreateDate.value.replace(/-/g,"/"), 'yyyy-MM-dd');
          //   }
          // });
          //console.log(that.dataArrayList);
        });
        //初始化  扫码盘库和手动盘库的值
        arrayListInfo.forEach(p=>{
         p["csum"].value=null;
        });
        if(that.com.GetStorageKey("arrrayListINFO")){
          let tempinfoList:Array<any> = that.com.GetStorageKey("arrrayListINFO")||[];
          tempinfoList.forEach(r=>{
            if(!arrayListInfo.find(u=>u.id.value==r.id.value)){
              arrayListInfo.push(r);
            }
          });
        }
        localStorage.setItem("arrrayListINFO",JSON.stringify(arrayListInfo));
        that.baseService.arrayData.forEach(items=>{
          items.Remark="";
          if(items["stock"]){
            if(!items["stock"].value){
              items["stock"].value=0;
            }
          }
          items["csum"].value=null;
          items["modalSHOE"] =false;
          items["cravingforRemk"] ="";
          items["Remark"] ="";
          
          items["seceltName"] = "请选择";
          items["FK_TBReasonsProductInventoryDifferences_ID"] ="";
          // if(items["csum"]){
          //   if(!items["csum"].value){
          //     if(items.stocknum){
          //       items["csum"].value=items.stocknum.value||0;
          //     }else{
          //       items["csum"].value=0;
          //     }
              
          //   }
          // }
        });
        // console.log(that.dataArrayList,"dataArrayList");
        /****上拉加载数据begin****/
        that.RecordCount = data.Status.RecordCount;
        if (that.RecordCount == data.Status.Datas.length || that.RecordCount == that.baseService.arrayData.length) {
          // that.infiniteScroll.disabled = true;
          if (that.infiniteScroll) {
            that.infiniteScroll.disabled = true;
          }
        } else {
          if (that.infiniteScroll) {
            that.infiniteScroll.disabled = false;
          }
        }
        /****上拉加载数据end****/
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      // console.log(error);
    });
  }



  /**
  * 下拉刷新数据
  * @param event
  */
  doRefresh(event) {
    const that = this;
    console.log("下拉率先你");
    console.warn("提示1");
    console.log(that.baseService.ListData);
    console.log("提示2");
    console.log(that.baseService.arrayData)
    // that.LoadData(1);

    // console.log(event);
    event.target.pullMax = 500;
    event.target.pullMin = 100;
    // console.log(this.ionRefresh);
    event.target.complete();
  }
  /**
   * 添加产品
   */
  // getProductList(){
  //   let that = this;
  //   that.productArrayList=[];
  //   const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
  //   let body = new WebParameterContext();
  //   body.Account = that.com.GetAccount;
  //   body.ConfigName = "TBProductInformationXML";
  //   // body.ConfigName="MemberManage";
  //   body.OpType = "query";
  //   body.ConfigType = "view";
  //   body.RowsPerPage = app.RowsPerPage;
  //   body.PageNumber = 1;
  //   body.Client.PageName = PageName;
  //   body.Client.ApiType = "Element";
  //   body.Client.Name = that.element.name;
  //   body.Client.ClientType = 2;
  //   if (that.platform.is("android")) {
  //     body.Client.ClientType = 0;
  //   } else if (that.platform.is("ios")) {
  //     body.Client.ClientType = 1;
  //   }
  //   that.http.post(app.DEFAULTURL, body).then(data => {
  //     if (data.ResponseMessage.Success) {
  //      that.productArrayList=data.Status.Datas;
  //     }else{
  //       that.msg.Alert(data.ResponseMessage.ErrorMessage);
  //     }

  //   }).catch(error => {
  //     console.log(error);
  //   });
  // }
  /**
   * 产品列表
   * @param event 
   */
  changeSelect(event) {

    // const that =this;
    // if(that.isAddProduct){
    //   that.isAddProduct = false;
    //   setTimeout(()=>{
    //     that.isAddProduct = true;
    //   },400);
    // }else{
    //   return;
    // }
    // // console.log(event.detail.value);
    // event.detail.value.forEach(detail=>{
    //   that.productArrayList.forEach(prod=>{
    //     if(prod.a_ID==detail){
    //       let details = {};
    //       details["product_id"]={"value":null,"text":""};
    //       details["id"]={"value":prod.a_ID,"text":""};
    //       details["groupName"]={"value":prod.a_ProductName,"text":""};
    //       details["stock"]={"value":null,"text":""};
    //       details["jdName"]={"value":prod.j_Name,"text":""};
    //       details["orderCreateDate"]={"value":null,"text":""};
    //       that.dataArrayList.push(details);
    //     }
    //   });
    // });
  }
  /**
   * 分销人
   * @param item 
   */
  onInput(item, event) {
    let that = this;
    console.log(1);
    let numvalue: any = that.com.GetNumber(event.target.value);
    setTimeout(() => {
      if (event.target.value) {
        console.log(numvalue);
        if (numvalue) {
        event.target.value = numvalue;
        item.csum.value = numvalue;
        } else {
          item.csum.value = 0;
          event.target.value = 0;
        }
      } else {
        event.target.value = null;
        item.csum.value = 0;
      }
      // if (item.product_id.value) {
      //   if (!item.stock.value) {
      //     //  that.msg.Alert("盘库数量不能小于零，默认为1");
      //     item.stock.value = 0;
      //     event.target.value = 0;
      //   }
      // }
    },100);
  }
  onInputroot(item, event) {
    let that = this;
    console.log(1);
    let numvalue: any = that.com.GetNumber(event.target.value);
    setTimeout(() => {
      if (event.target.value) {
        console.log(numvalue);
        if (numvalue) {
        event.target.value = numvalue;
        item.csum.value = numvalue;
        } else {
          item.csum.value = 0;
          event.target.value = 0;
        }
      } else {
        event.target.value = null;
        item.csum.value = 0;
      }
      // if (item.product_id.value) {
      //   if (!item.stock.value) {
      //     //  that.msg.Alert("盘库数量不能小于零，默认为1");
      //     item.stock.value = 0;
      //     event.target.value = 0;
      //   }
      // }
    },100);
  }
  Eventdatetime(event, item) {
    item.orderCreateDate.value = event.detail.value;
    // console.log(item);
    // console.log(event);
  }
  //消费者退货
  //删除选中的数据
  deleteReturn(item) {
    const that = this;
    that.msg.Confirm("确定删除该产品吗？").then(fail => {
      if (fail) {
        console.log("删除后的退货数据", that.baseService.ListData);
        console.log("删除后的退货数据", that.baseService.arrayData);
        that.baseService.arrayData = that.baseService.arrayData.filter(n => n.ProductInfoCode != item.ProductInfoCode);
        that.baseService.ListData = that.baseService.ListData.filter(n => n.ProductInfoCode != item.ProductInfoCode);
      }

    });

    console.log("删除后的退货数据", that.baseService.ListData);
    console.log("删除后的退货数据", that.baseService.arrayData);
  }
  /**
   * 提交数据
   */
  EventSubmitClick() {
    const that = this;
    if (that.pageName == "ReturnGoods") {
      let param: any;
      let newArr = [];
      //  console.log(that.baseService.ListData, 'jieguo');return;
      that.baseService.arrayData.forEach(it => {
        console.log("显示的数据显示的数据++++++++++++++++")
        console.log(it)
        let TankBarcodelen = it.TankBarcode.split(",").length;
        let BoxCountlen = it.BoxCount;
        console.log("新的数据传参");
        console.log(TankBarcodelen);
        console.log(BoxCountlen);
        let newObj = {};
        if (newArr.find(x => x.Code == it["ProductInfoCode"] && x.PurchaseID==it.PurchaseID)) {
          newArr.find(x => x.Code == it["ProductInfoCode"])["CodeIDS"].push({ CodeID: it["TankBarcode"], PurchaseRecordID: it["PurchaseID"], Count: it["BoxCount"] });

          // return;
          //  if(TankBarcodelen>1){
          //   newArr.find(x=>x.Code==it["ProductInfoCode"])["CodeIDS"].push({CodeID:it["TankBarcode"],PurchaseRecordID:it["PurchaseID"],Count:BoxCountlen});
          //  }else{
          //   newArr.find(x=>x.Code==it["ProductInfoCode"])["CodeIDS"].push({CodeID:it["TankBarcode"],PurchaseRecordID:it["PurchaseID"],Count:1});
          //  }

          // newArr.find(x=>x.Code==it["ProductInfoCode"].push({CodeID:it["TankBarcode"],PurchaseRecordID:it["PurchaseID"]}));
        } else {
          newObj["Code"] = it["ProductInfoCode"];
          newObj["CodeIDS"] = [];
          newObj["CodeIDS"].push({ CodeID: it["TankBarcode"], PurchaseRecordID: it["PurchaseID"], Count: it["BoxCount"] })
          // if(TankBarcodelen>1){
          //   newObj["CodeIDS"].push({CodeID:it["TankBarcode"],PurchaseRecordID:it["PurchaseID"],Count:BoxCountlen})
          // }else{
          //   newObj["CodeIDS"].push({CodeID:it["TankBarcode"],PurchaseRecordID:it["PurchaseID"],Count:1})
          // }

          newArr.push(newObj);
        }
      });
      let giftArray:Array<any> = [];
      that.baseService.giftArrayList.forEach(items=>{
        giftArray.push({"FK_TBGift_ID":items.a_FK_TBGift_ID,"Order_ID":items.a_Order_ID,"GiftName":items.b_Name,"Num":items.Num});
      })
      if (newArr.length <= 0) {
        that.msg.Alert("请扫码退货");
        that.baseService.FixedSubmitBtn.isSubmitData = true;
        return;
      }
      console.log("保存的数据111", newArr);
      // return;
      let paramBody = {};
      const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
      let body = new WebParameterContext();
      body.Account = that.com.GetAccount;
      body.ConfigName = "ProductReturn";
      body.OpType = "EDITE";
      body.ConfigType = "form";
      body.RowsPerPage = app.RowsPerPage;
      body.PageNumber = 0;
      body.Client.PageName = PageName;
      body.Client.ApiType = "Element";
      body.Client.Name = that.element.name;
      body.Client.ClientType = 2;
      if (that.platform.is("android")) {
        body.Client.ClientType = 0;
      } else if (that.platform.is("ios")) {
        body.Client.ClientType = 1;
      }

      paramBody["Remark"] = that.Remark || "";
      paramBody["Products"] = newArr;
      paramBody["Gifts"] = giftArray;
      console.log( paramBody);
      body.RequestBody = JSON.stringify(paramBody);
      
      // return;
      that.msg.Confirm("确认提交吗？", "取消", "确定", "", false).then(res => {
        if (res) {
          that.msg.Loading("请求中，请稍后...").then(load=>{
            that.http.post(app.DEFAULTURL, body).then(data => {
              load.dismiss();
              that.baseService.FixedSubmitBtn.isSubmitData = true;
              /****判断是否第一页end****/
              if (data.ResponseMessage.Success) {
                console.log(data);
                that.msg.Alert("提交成功").then(res=>{
                   if(res){
                    that.baseService.ListData = new Array<any>();
                    that.baseService.arrayData = new Array<any>();
                    that.com.goBack();
                   }
                });
              } else {
                that.msg.Alert(data.ResponseMessage.ErrorMessage);
              }
            }).catch(error => {
              load.dismiss();
              that.baseService.FixedSubmitBtn.isSubmitData = true;
              console.log(error);
            });
            load.present();
          });
        }
      })


    }
    else {
      let inventoryObj = that.com.InventoryDatelimit();
      console.log("请求提交数据");
      if (!inventoryObj["isSubmit"]) {
        that.msg.Alert("盘库日期仅限当月" + inventoryObj["begin"] + "号至" + inventoryObj["end"] + "号");
        that.baseService.FixedSubmitBtn.isSubmitData = true;
        return;
      }
      let arrayDataList: Array<any> = new Array<any>();
      let _tempArrayInfo:Array<any> =that.com.GetStorageKey("arrrayListINFO")||[];
      that.baseService.arrayData.forEach(items => {
        if(_tempArrayInfo.find(t=>t.csum.value!=items.csum.value || items.stock.value)){
          let num: number = items.stock.value || 0;
          let num2: number = items.csum.value || 0;//手动盘库
          let sumnum:number = num+num2;
          let fk_tbproductstock_id: any = items.id.value;//赠品ID
          let _obj = {};
          if (fk_tbproductstock_id) {
            console.log(items,"提交数据")
            _obj["FK_TBProductInformation_ID"] = items.id.value;
            _obj["FK_TBProductStock_ID"] = items.fk_tbproductstock_id.value;
            _obj["Repertory"] = sumnum;
            _obj["StockNum"] = items.stocknum.value;
            _obj["Remark"]=items.cravingforRemk;//备注信息
            _obj["FK_TBReasonsProductInventoryDifferences_ID"]=items.FK_TBReasonsProductInventoryDifferences_ID;//备注信息
           
            if (items.IntegralCodeDetailList && items.IntegralCodeDetailList.length > 0) {
              _obj["IntegralCodeDetailList"] = items.IntegralCodeDetailList;//箱码或者罐码
              _obj["BoxCount"]=items.BoxCount;
            }
            arrayDataList.push(_obj);
          }
        }
      });
      if (arrayDataList.length <= 0) {
        that.baseService.FixedSubmitBtn.isSubmitData = true;
        that.msg.Alert("未填写库存数量");
        return;
      }
      let ismodal:boolean=false;//是否盘库数量不对  没有写备注
      that.baseService.arrayData.forEach(item=>{
        if(item.stock.value || item.csum.value || item.csum.value==0){
          if(item.stocknum.value != (item.stock.value+item.csum.value) ){
            if(!item.FK_TBReasonsProductInventoryDifferences_ID){
              item.color=true;
              ismodal=true;
            }
            // if(!item.Remark.trim()){
            //   console.log(item)
            //   item.color=true;
            //   ismodal=true;
            // }
          }
        }
      });
      if(ismodal){
        that.msg.Alert("对应产品当前库存与盘库库存有差异,请输入差异原因");
        return;
      }
      console.log("EventSubmitClick", arrayDataList);
      that.requestData(arrayDataList);
      // if (this.baseService.arrayData.find(item => item.stocknum.value != (item.stock.value+item.csum.value))) {
      //   this.presentModal(arrayDataList);//添加remark
      // }else{
      //   that.requestData(arrayDataList);
      // }
    
    }
  }
  //备注输入
  RemarkInputItem(e,item) {
    let that = this;
    // debugger;
    if (e && e.target.value) {
        if( item.color){
          item.color=false;
        }
      if (e.target.value.length > 300) {
        e.target.value = e.target.value.substr(0, 300);
        item.Remark = e.target.value;
      }
    }
  }
  //备注输入
  RemarkInput(e) {
    let that = this;
    if (e && e.target.value) {
      if (e.target.value.length > 300) {
        e.target.value = e.target.value.substr(0, 300);
        that.Remark = e.target.value;
      }
    }
  }



// 输入数量
  ChangeNumstore(event,item){
        let that = this;
        // console.log(1);
        setTimeout(() => {
          if (event.target.value) {
            let numvalue: any = this.com.GetNumber(event.target.value);
            if (numvalue) {
              if(numvalue>item.a_Num){
                  item.Num=item.a_Num;
                 event.target.value =item.a_Num;
              }else{
                item.Num= numvalue;
              event.target.value = numvalue;
              }
              
            } else {
              item.Num= 0;
              event.target.value = 0;
            }
          } else {
            event.target.value = null;
            item.Num= 0;
          }
        }, 400);
  }
/**
 * 提交数据接口
 * @param arrayDataList 需要提交的数组
 * @param ismodal 是否modal弹框调用
 */
  public requestData(arrayDataList:Array<any>,ismodal:boolean=false)
  {
    var that=this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    body.ConfigName = "AddInventory";//"TBProductInventoryXML";
    body.OpType = "add";
    body.ConfigType = "form";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = 0;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    // if(indexs>=0){
    //   body.OpType = "EDITE";
    // }

    body.RequestBody = JSON.stringify(arrayDataList);
    console.log(arrayDataList);
    if(ismodal){//如果是弹框则直接提交
      that.http.post(app.DEFAULTURL, body).then(data => {
        that.baseService.FixedSubmitBtn.isSubmitData = true;
        /****判断是否第一页end****/
        if (data.ResponseMessage.Success) {
          that.msg.Alert("盘库成功").then(data => {
            if (data) {
              that.com.goBack();
            }
          });
        } else {
          that.msg.Alert(data.ResponseMessage.ErrorMessage);
          if(data.ResponseMessage.ErrorCode==-1){
            let returnList:Array<any> = new Array<any>();
            if(data.Status && data.Status.Datas){
              if(data.Status.Datas.length>0){
                returnList=data.Status.Datas||[];
                debugger;
                returnList.forEach(item=>{
                  that.baseService.arrayData.forEach(prod=>{
                    if(prod.fk_tbproductstock_id.value==item.ID){
                      prod.stocknum.value=item.Repertory||0;
                    }
                  })
                });
              }
            }
          }
        }
      }).catch(error => {
        that.baseService.FixedSubmitBtn.isSubmitData = true;
        console.log(error);
      });
    }else{
      that.msg.Confirm("产品盘库总数为手动盘库数量+扫码盘库数量的合计，是否已全部确认？", "取消", "确定", "", false).then(res => {
        if (res) {
          that.http.post(app.DEFAULTURL, body).then(data => {
            that.baseService.FixedSubmitBtn.isSubmitData = true;
            /****判断是否第一页end****/
            if (data.ResponseMessage.Success) {
              console.log(data);
              that.msg.Alert("盘库成功").then(data => {
                if (data) {
                  that.com.goBack();
                }
              });
            } else {
              that.msg.Alert(data.ResponseMessage.ErrorMessage);
              if(data.ResponseMessage.ErrorCode==-1){
                let returnList:Array<any> = new Array<any>();
                if(data.Status && data.Status.Datas){
                  if(data.Status.Datas.length>0){
                    returnList=data.Status.Datas||[];
                    debugger;
                    returnList.forEach(item=>{
                      that.baseService.arrayData.forEach(prod=>{
                        if(prod.fk_tbproductstock_id.value==item.ID){
                          prod.stocknum.value=item.Repertory||0;
                        }
                      })
                    });
                  }
                }
              }
            }
          }).catch(error => {
            that.baseService.FixedSubmitBtn.isSubmitData = true;
            console.log(error);
          });
        }
      });
    }
 
  }

  /**
     * 提交数据
     */
  //EventSubmitClick()
  //{
  //  console.log("EventSubmitClick",this.baseService.arrayData);
  //  if(this.baseService.arrayData.find(item=>item.stocknum.value!=item.stock.value))
  //  {
  //    this.presentModal();
  //  }

  //}

  async presentModal(arrayDataList:Array<any>) {
    var that=this;
    // debugger;
    const modal = await this.modal.create({
      component: MzModalPage,
      cssClass: 'my-custom-class',
      componentProps: {
        'configName': this.pageName,
        "item":that.Remark
      }
    });
 
      await modal.present();
    const { data } = await modal.onWillDismiss();
    if(data&&data.request)
    {
      that.Remark=data["result"]||"";
      arrayDataList.forEach((item)=>{
        item["Remark"]=that.Remark;
      });
      that.requestData(arrayDataList,true);
    }else{
      return;
    }

  }

   /**
   * 差异原因
   */
    reasonsforDifferences(){
      let that = this;
      const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
      let body = new WebParameterContext();
      body.Account = that.com.GetAccount;
        body.ConfigName = "TBReasonsProductInventoryDifferencesXML";
      // body.ConfigName="MemberManage";
      body.OpType = "query";
      body.ConfigType = "view";
      body.RowsPerPage = app.RowsPerPage;
      body.PageNumber = 1;
      body.Client.PageName = PageName;
      body.Client.ApiType = "Element";
      body.Client.Name = that.element.name;
      body.Client.ClientType = 2;
      if (that.platform.is("android")) {
        body.Client.ClientType = 0;
      } else if (that.platform.is("ios")) {
        body.Client.ClientType = 1;
      }
      let _obj={};
      _obj["type"] =0;
      body.RequestBody = JSON.stringify(_obj);
      that.http.post(app.DEFAULTURL, body).then(data => {
  
        if (data.ResponseMessage.Success) {
         let  _reasonsforDifferencesList =  data.Status.Datas[0];
         that._type = _reasonsforDifferencesList;
          data.Status.Datas.forEach(items=>{
            items["isCheck"]= false;
            if(_reasonsforDifferencesList.a_ID == items.a_ID){
              items["isCheck"]= true;
            }
          });
          that.reasonsforDifferencesList= data.Status.Datas;
         
          console.log(that.reasonsforDifferencesList,"差异原因")
        }
  
      }).catch(error => {
        that.apiObj['status'] = false;
        that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
        that.loading = true;
        // console.log(error);
      });
    }
  async presentModaldifferences(item) {
    var that=this;
    // debugger;
   this.reasonsforDifferences();
    console.log(that.reasonsforDifferencesList,"差异原因")
    const modal = await this.modal.create({
      component: ReasonsDifferencesPage,
      cssClass: 'reasons-differences',
      componentProps: {
        'configName': this.pageName,
        "item":that.Remark,
        "fisttype":that._type,
        "reasonsforDifferenceslo":that.reasonsforDifferencesList
      }
    });
 
      await modal.present();
    const { data } = await modal.onWillDismiss();
    console.log(data)
    if(data.seceltName){
      item.seceltName = data.seceltName;
      item.FK_TBReasonsProductInventoryDifferences_ID = data.FK_TBReasonsProductInventoryDifferences_ID
      item.cravingforRemk= data.cravingforRemk;
    }
    console.log(data.cravingforRemk)
   console.log(data.FK_TBReasonsProductInventoryDifferences_ID)
    // if(data&&data.request)
    // {
    //   that.Remark=data["result"]||"";
    //   arrayDataList.forEach((item)=>{
    //     item["Remark"]=that.Remark;
    //   });
    //   // that.requestData(arrayDataList,true);
    // }else{
    //   return;
    // }

  }
/**
 * 弹窗处理事件
 */
// 显示弹窗
// eventClick(item){
// const that =this;
// item.modalSHOE = true;
// that.modalSHOEremark = false;
// this.reasonsforDifferences();
// }
//  EventSelect(item){
//   const that =this;
//   that.cravingforRemk ="";
//   // item.isCheck =false;
//   that.reasonsforDifferencesList.forEach(items=>{
//     items["isCheck"]= false;
//     if(item.a_ID == items.a_ID){
//       items["isCheck"]= true;
//     }
//   });
//   console.log(item,"点击")
//   if(item.a_Name == "其它"){
//     that.modalSHOEremark = true;
//   }
//   // item.isCheck = item.a_ID;
//   that._type=item;
  
// }
cleashideModal(item){
  const that =this;
  that.cravingforRemk ="";
  item["FK_TBReasonsProductInventoryDifferences_ID"] =""
  item.seceltName = "请选择"
  that.reasonsforDifferences();
}
  // 取消
  dismissModal(item) {
    const that=this;
    let _array:Array<any> = new Array<any>();
    item.modalSHOE = false;
  }
  // // 确定
  // comfireModal(item,i) {
  //     const that=this;
  //     console.log(that._type)
  //     console.log(that.cravingforRemk.length)
  //     console.log(item.a_Name)
  //     that.cravingforRemk = that.cravingforRemk.replace(/(^\s*)|(\s*$)/g, "")
  //       if(that.cravingforRemk.length==0 && that._type.a_Name == "其它"){
  //         that.msg.Alert("差异原因不能为空");
  //         return;
  //       }
  //       console.log(item,"确定mmmmm")
  //       item.seceltName = that._type.a_Name;
  //       item.cravingforRemk = that.cravingforRemk;
  //       item.Remark = that.cravingforRemk;
  //       item.modalSHOE = false;
  //       item.FK_TBReasonsProductInventoryDifferences_ID = that._type.a_ID;
  // }
  // 差异原因
  // RemarkInputcravingfor(e){
  //   let that = this;
  //   console.log( e.target.value)
  //   e.target.value = e.target.value.replace(/(^\s*)|(\s*$)/g, "");
  //   console.log( typeof e.target.value)
  //   if (e && e.target.value) {
  //     if (e.target.value.length > 120) {
  //       e.target.value = e.target.value.substr(0, 120);
  //       that.cravingforRemk = e.target.value.replace(/(^\s*)|(\s*$)/g, "");
  //     }
  //   }
  // }
 
}